import React from 'react';
import { Backdrop, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  }
}));

function Loading() {
  const classes = useStyles();

  const visible = useSelector((store) => {
    return store.loadingReducer.visible;
  });

  return (
    <Backdrop className={classes.backdrop} open={visible}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Loading;
